import { UAParser } from 'ua-parser-js';
import { getMCID } from '@stencil/flights-utils';
const parser = new UAParser();

const NOT_AVAILABLE = 'NA';

function getTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || NOT_AVAILABLE;
  } catch (e) {
    return NOT_AVAILABLE;
  }
}

export const getDeviceData = appName => {
  const parserResult = parser.getResult();
  const deviceData = {
    browser: parserResult.browser.name,
    browser_version: parserResult.browser.version,
    device_id: getMCID(),
    flavour: parserResult.device.type === 'mobile' ? 'PWA' : 'Desktop',
    manufacturer: parserResult.device.vendor,
    model: parserResult.device.model,
    os_version: `${parserResult.os.name} ${parserResult.os.version}`,
    user_agent: navigator.userAgent,
    platform: parserResult.device.type === 'mobile' ? 'PWA' : 'Desktop',
    os: parserResult.os.name,
    network_type: navigator.connection ? navigator.connection.effectiveType : NOT_AVAILABLE,
    time_zone: getTimeZone(),
    app_ver: appName || NOT_AVAILABLE,
    build_ver: NOT_AVAILABLE,
    ip_addr: NOT_AVAILABLE
  };
  if (window?.screen && window?.screen?.width) {
    const width = window.screen.width ? window.screen.width : '';
    const height = window.screen.height ? window.screen.height : '';
    deviceData.device_resolution = `${width}*${height}`;
  }

  return deviceData;
};

export const addWebVitalsScript = ({ appName }) => {
  const num = Math.floor(Math.random() * 20);
  if (num >= 10) return;
  const queue = new Set();
  const pdtUrl = 'https://pdt.makemytrip.com/dts/s/da/n';
  function createPayload(name, value, rating, attribution) {
    const device = getDeviceData(appName);
    const payload = {
      event_detail: {
        event_name: `web_vitals_flights_gi_values_${name}`,
        event_type: 'action',
        event_value: value,
        event_id: '',
        event_timestamp: new Date().getTime()
      },
      device_context: {
        app_ver: device.app_ver || NOT_AVAILABLE,
        build_ver: device.build_ver || NOT_AVAILABLE,
        device_id: device.device_id || NOT_AVAILABLE,
        ip_addr: device.ip_addr || NOT_AVAILABLE,
        os: device.os || NOT_AVAILABLE,
        os_version: device?.os_version?.toLowerCase() || '',
        network_type: device.network_type || NOT_AVAILABLE,
        platform: device.platform?.toLowerCase(),
        time_zone: device.time_zone || NOT_AVAILABLE
      },
      context: {
        template_id: 65871,
        topic_name: 'mmt_commons_b2c_pdt_client_metric_logging'
      },
      page_context: {
        page_name: window?.location?.href || ''
      },
      event_tracking_context: {
        template_id: 65871,
        topic_name: 'mmt_commons_b2c_pdt_client_metric_logging',
        session_visit_number: 1,
        env: 'prod',
        funnel_source: 'gi_flights',
        session_id: device.device_id || NOT_AVAILABLE
      },
      user_context: {
        is_logged_in: false,
        marketing_cloud_id: window?.s?.marketingCloudVisitorID || NOT_AVAILABLE
      }
    };
    switch (name) {
      case 'CLS':
        payload.event_detail.event_id = attribution.largestShiftTarget;
        break;
      case 'LCP':
        payload.event_detail.event_id = attribution.element;
        break;
      case 'FID':
      case 'INP':
        payload.event_detail.event_id = attribution.eventTarget;
        // payload.event_detail.inp_type = attribution.eventType;
        // payload.event_detail.inp_time = attribution.eventTime;
        // payload.event_detail.inp_load_state = attribution.loadState;
        break;
      default:
        break;
    }
    return payload;
  }
  function addToQueue(metric) {
    const { name, value, rating, attribution } = metric;
    const payload = createPayload(name, value, rating, attribution);
    queue.add(payload);
  }

  function initiatePDTCall(body) {
    fetch(pdtUrl, {
      body,
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        'request-data-encoding': 'json'
      }
    });
  }

  function handleLog(metric) {
    const { name, value, rating, attribution } = metric;
    const payload = createPayload(name, value, rating, attribution);
    initiatePDTCall(JSON.stringify([payload]));
  }

  function flushQueue() {
    if (queue.size > 0) {
      const events = Array.from(queue);
      const body = JSON.stringify([...events]);
      initiatePDTCall(body);
      queue.clear();
    }
  }

  const handleOnload = () => {
    webVitals.onFCP(handleLog);
    webVitals.onLCP(handleLog);
    webVitals.onCLS(addToQueue);
    webVitals.onFID(addToQueue);
    webVitals.onINP(addToQueue);
    webVitals.onTTFB(addToQueue);
  };
  addScript(
    'https://unpkg.com/web-vitals@3/dist/web-vitals.attribution.iife.js',
    true,
    true,
    handleOnload,
    true
  );
  if (typeof window !== 'undefined') {
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        flushQueue();
      }
    });

    window.addEventListener('pagehide', flushQueue);
  }
};

export const addScript = (src, async = !0, defer = !0, onLoad = () => {}, appendOnBody = false) => {
  if (src) {
    const newScript = document.createElement('script');
    newScript.type = 'text/javascript';
    newScript.async = async;
    newScript.defer = defer;
    newScript.src = src;
    newScript.onload = onLoad;
    if (appendOnBody) document.getElementsByTagName('body')[0].appendChild(newScript);
    else document.getElementsByTagName('head')[0].appendChild(newScript);
  }
};
